// Inspired by vuetify:
// https://github.com/vuetifyjs/vuetify/blob/8bb752b210d25fbebcea12cd073d2ce4986f5e12/packages/vuetify/src/services/breakpoint/index.ts
const getClientWidth = () => {
    return Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
}

const getClientHeight = () => {
    return Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
}

export default {
    data() {
        return {
            resizeTimeout: 0,
            clientWidth: getClientWidth(),
            clientHeight: getClientHeight()
        }
    },
    computed: {
        $breakpoint() {
            let xs = this.clientWidth < 576
            let sm = this.clientWidth < 768 && !xs
            let md = this.clientWidth < 992 && !(sm || xs)
            let lg = this.clientWidth < 1200 && !(md || sm || xs)
            let xl = this.clientWidth >= 1200 && !(lg || md || sm || xs)

            let xsOnly = xs
            let smOnly = sm
            let smAndDown = (xs || sm) && !(md || lg || xl)
            let smAndUp = !xs && (sm || md || lg || xl)
            let mdOnly = md
            let mdAndDown = (xs || sm || md) && !(lg || xl)
            let mdAndUp = !(xs || sm) && (md || lg || xl)
            let lgOnly = lg
            let lgAndDown = (xs || sm || md || lg) && !xl
            let lgAndUp = !(xs || sm || md) && (lg || xl)
            let xlOnly = xl

            let name
            switch (true) {
            case (xs):
                name = 'xs'
                break
            case (sm):
                name = 'sm'
                break
            case (md):
                name = 'md'
                break
            case (lg):
                name = 'lg'
                break
            default:
                name = 'xl'
                break
            }

            return {
                // Definite breakpoint.
                'xs': xs,
                'sm': sm,
                'md': md,
                'lg': lg,
                'xl': xl,

                // Useful e.g. to construct CSS class names dynamically.
                'name': name,

                // Breakpoint ranges.
                'xsOnly': xsOnly,
                'smOnly': smOnly,
                'smAndDown': smAndDown,
                'smAndUp': smAndUp,
                'mdOnly': mdOnly,
                'mdAndDown': mdAndDown,
                'mdAndUp': mdAndUp,
                'lgOnly': lgOnly,
                'lgAndDown': lgAndDown,
                'lgAndUp': lgAndUp,
                'xlOnly': xlOnly,

                // For custom breakpoint logic.
                'width': this.clientWidth,
                'height': this.clientHeight
            }
        }
    },
    methods: {
        $_updateDimensions() {
            this.clientWidth = getClientWidth()
            this.clientHeight = getClientHeight()
        },

        onResize() {
            clearTimeout(this.resizeTimeout)

            // Added debounce to match what
            // v-resize used to do but was
            // removed due to a memory leak
            // https://github.com/vuetifyjs/vuetify/pull/2997
            this.resizeTimeout = window.setTimeout(this.$_updateDimensions.bind(this), 200)
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.$_updateDimensions()
            window.addEventListener('resize', this.onResize, {'passive': true})
        })
    },
    destroyed() {
        window.removeEventListener('resize', this.onResize)
    }
}
